import { InstrumentationPageSession } from './InstrumentationPayload';

export class PageSession
{
    private readonly _pageNumber:   number;
    private readonly start:         number;
    private end:                    number;

    get pageNumber(): number { return this._pageNumber; }

    constructor(pageNumber: number) {
        this._pageNumber = pageNumber;
        this.start = Date.now();
    }

    endPage(): void {
        this.end = Date.now();
    }

    toPayload(): InstrumentationPageSession {
        return {
            pageNumber: this.pageNumber,
            start:      new Date(this.start).toUTCString(),
            end:        new Date(this.end).toUTCString()
        };
    }
}
